export const about = {
  paragraphs: [
    'Lõdvik on Pärnu autoremonditöökoda. Veermik, hooldus, diagnostika ja rehvivahetus — läbipaistvad hinnad, asjatundlik töö.',
    'Diagnostikast rehvivahetuseni, õlivahetusest veermikuni: iga samm on mõõdetav, arusaadav ja teie aega austav.',
  ],
  callouts: [
    'Kliendi enda toodud varuosadega garantii ei kehti.',
    'Teostame ka pisemaid keevitustöid.',
  ],
};
